var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonStanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-person-standing",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 20 3-6 3 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 8 6 2 6-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonStanding);
export default __webpack_public_path__ + "static/media/person-standing.0b49149b47333a4068f67a4863572926.svg";
export { ForwardRef as ReactComponent };